export const formatPrice = (toFormat: number | string): string => {
  if (typeof toFormat === 'string') toFormat = Number(toFormat);
  return `$${new Intl.NumberFormat().format(toFormat)}`;
};
